/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Input, Checkbox, Label, Title } from '@fnacdarty/back-office-ui';
import DatePicker from 'react-datepicker';

import { NotificationManager } from 'react-notifications';
import { addMonths, sub, setHours, setMinutes } from 'date-fns';

import { Bars } from 'react-loader-spinner';
import {
	StyledError,
	StyledSucess,
	StyledBlockModal,
	StyledBlockDateDeb,
	StyledBlockDateFin,
	StyledBlockErreurIndispo,
	DatePickerContainer,
	StyledCheckboxBlock,
	StyledEndTitle,
	StyledArrow,
	StyledDateRow,
	StyledDateContainer,
	StyledDate,
	CustomButton,
} from './index.styled';
import { Modal } from '../../../../layouts';

import 'react-datepicker/dist/react-datepicker.css';
import {
	addUnaivability,
	editPlanning,
	getCalendarEvents,
	getFormatedEvents,
} from '../../utils/calendar';
import {
	getFormattedTime,
	timeValide,
	isSunday,
	getFormattedUTCDate,
	getBrutStringDate,
} from '../../../../utils/date';
import 'react-notifications/lib/notifications.css';
import CheckList from '../../../../components/common/CheckList';

const Switch = (props) => {
	const { test, children } = props;
	return children.find((child) => child.props.value === test);
};
const CustomInput = ({ value, onClick, placeholder }) => (
	<CustomButton onClick={onClick}>{value || placeholder}</CustomButton>
);

function EditPlanning({
	showModalEditPlanning,
	display,
	selectedResource,
	setFormatedEvents,
	theme,
	startWeekDate,
	endWeekDate,
	hasUndefinedTitle,
	isVersionPC,
}) {
	const [status, setStatus] = useState({
		loading: false,
		error: '',
		success: '',
	});
	const [end, setEndDate] = useState(sub(endWeekDate, { days: 1 }));
	const [showDatePicker, setShowDatePicker] = useState(false);
	const handleDuplicateChecked = () => {
		setShowDatePicker(!showDatePicker);
	};
	const [list, setList] = useState([
		{ value: '1', label: 'Lundi', checked: false },
		{ value: '2', label: 'Mardi', checked: false },
		{ value: '3', label: 'Mercredi', checked: false },
		{ value: '4', label: 'Jeudi', checked: false },
		{ value: '5', label: 'Vendredi', checked: false },
		{ value: '6', label: 'Samedi', checked: false },
		{ value: '0', label: 'Dimanche', checked: false },
	]);

	useEffect(() => {
		const newCheckList = list.map((day) => {
			const dayIndex = Number(day.value);
			return { ...day, checked: hasUndefinedTitle[dayIndex] };
		});
		// Only update the state if the value of `list` has changed
		if (JSON.stringify(list) !== JSON.stringify(newCheckList)) {
			setList(newCheckList);
		}
	}, []);

	const newWeek = list.map((day) => ({
		[day.value]: day.checked,
	}));

	const weekType = JSON.stringify(newWeek);
	const resource = selectedResource.id;
	const [isLoading, setIsLoading] = useState(false);

	const handleEditPlanningClick = async (response) => {
		if (response) {
			setIsLoading(true);
			const formatedStartDate = getFormattedTime(startWeekDate);
			const formatedEndDate = getFormattedTime(end);
			const result = await editPlanning(
				formatedStartDate,
				formatedEndDate,
				resource,
				weekType,
			);
			if (result) {
				const res = await getCalendarEvents(resource);
				if (res) {
					setFormatedEvents(getFormatedEvents(res, theme));
				}

				NotificationManager.success('Le planning a été mis à jour', '');
				display('none');
				setStatus({
					error: '',
				});
			} else {
				display('none');
				NotificationManager.error(
					"Une erreur s'est produite lors de mise à jour du planning",
					'',
				);
			}
		} else {
			setStatus({
				error: '',
				loading: false,
			});
			display('none');
		}
	};
	return (
		<>
			{showModalEditPlanning && (
				<Modal
					onClickCallback={handleEditPlanningClick}
					title="Gestion Planning"
					cancelAction={!isLoading ? 'Annuler' : ''}
					confirmAction={!isLoading ? 'Mettre à jour' : ''}
					style={{
						position: 'fixed',
						width: isVersionPC() ? '40%' : '90%',
						minWidth: isVersionPC() ? '500px' : '',
					}}
				>
					{!isLoading ? (
						<StyledBlockModal>
							<CheckList
								style={{
									alignItems: 'center',
									marginTop: '20px',
								}}
								list={list}
								updateList={setList}
								isVersionPC={isVersionPC}
							/>
							<StyledCheckboxBlock>
								<Checkbox
									id="duplicate"
									onChange={handleDuplicateChecked}
								/>
								<Label
									htmlFor="duplicate"
									style={{
										marginLeft: '5px',
									}}
								>
									<Title level={4}>
										Dupliquer sur plusieurs semaines
									</Title>{' '}
									<Title level={5}> (3 mois maximum)</Title>
								</Label>
							</StyledCheckboxBlock>

							{showDatePicker && (
								<DatePickerContainer>
									<StyledEndTitle>Fin:</StyledEndTitle>
									<DatePicker
										id="date_fin_planning"
										selected={end}
										onChange={(date) => setEndDate(date)}
										dateFormat="dd/MM/yyyy"
										locale="fr"
										className="date_fin"
										customInput={
											<CustomInput placeholder="Fin" />
										}
										placeholderText="Date fin du planning"
										showWeekNumbers
										filterDate={isSunday}
										minDate={startWeekDate}
										maxDate={addMonths(startWeekDate, 3)}
									/>
								</DatePickerContainer>
							)}
						</StyledBlockModal>
					) : null}

					{isLoading ? (
						<StyledBlockModal>
							<Bars
								height="80"
								width="80"
								color="#b8cbf2"
								ariaLabel="bars-loading"
								wrapperStyle={{}}
								wrapperClass=""
								visible={true}
							/>
						</StyledBlockModal>
					) : null}
				</Modal>
			)}
		</>
	);
}

function AddUnavailable({
	// eslint-disable-next-line react/prop-types
	showModalAddIndispo,
	// eslint-disable-next-line react/prop-types
	display,
	// eslint-disable-next-line react/prop-types
	selectedResource,
	// eslint-disable-next-line react/prop-types
	setFormatedEvents,
	// eslint-disable-next-line react/prop-types
	theme,
	isVersionPC,
}) {
	const [status, setStatus] = useState({
		loading: false,
		error: '',
		success: '',
	});
	const [startDate, setStartDate] = useState();
	const [endDate, setEndDate] = useState();
	const [isLoading, setIsLoading] = useState(false);
	const [selectedDates, setSelectedDates] = useState(null);
	const handleAddIndispoClick = async (response) => {
		setStatus({
			error: '',
		});
		const resource = selectedResource.id;
		if (response) {
			if (
				selectedDates === undefined ||
				selectedDates === null ||
				selectedDates === ''
			) {
				setStatus({
					error: 'Veuillez sélectionner une date',
				});
			} else if (
				startDate === undefined ||
				startDate === null ||
				startDate === ''
			) {
				setStatus({
					error: 'Veuillez sélectionner une date de début',
				});
			} else if (
				endDate === undefined ||
				endDate === null ||
				endDate === ''
			) {
				setStatus({
					error: 'Veuillez sélectionner une date de fin',
				});
			} else if (!timeValide(startDate) || !timeValide(endDate)) {
				setStatus({
					error: 'Veuillez sélectionner une heure de début et une heure de fin ',
				});
			} else if (startDate < endDate && startDate !== endDate) {
				const formatedStartDate = getFormattedTime(
					new Date(
						selectedDates.setHours(
							startDate.getHours(),
							startDate.getMinutes(),
						),
					),
				);
				const formatedEndDate = getFormattedTime(
					new Date(
						selectedDates.setHours(
							endDate.getHours(),
							endDate.getMinutes(),
						),
					),
				);
				const resCalendar = await getCalendarEvents(resource);
				const dateIndispo = getBrutStringDate(formatedStartDate);
				let isAddIndispo = true;
				let activitiesDuration = 0;
				let dayDuration = 0;
				let availabiltyDuration = 0;
				let unavailabiltiesDuration = 0;
				let isOpenPlanning = true;
				let planningStartDate = null;
				let planningEndDate = null;
				let isAvailableSlotsToAddUnavailability = true;

				if (resCalendar && resCalendar.length > 0) {
					resCalendar.forEach((item) => {
						if (getBrutStringDate(item.date) === dateIndispo) {
							planningStartDate = new Date(
								item.availabilityStartAt,
							);
							planningEndDate = new Date(item.availabilityEndAt);
							dayDuration +=
								new Date(item.availabilityEndAt) -
								new Date(item.availabilityStartAt);
							if (item.activities) {
								item.activities.forEach((act) => {
									activitiesDuration +=
										new Date(act.endAt) -
										new Date(act.startAt);
								});
							}
							if (item.unavailabilities) {
								item.unavailabilities.forEach((indispo) => {
									unavailabiltiesDuration +=
										new Date(indispo.end) -
										new Date(indispo.start);

									if (
										(new Date(formatedStartDate) <=
											new Date(indispo.start) &&
											new Date(formatedEndDate) >=
												new Date(indispo.end)) ||
										(new Date(formatedStartDate) >=
											new Date(indispo.start) &&
											new Date(formatedStartDate) <
												new Date(indispo.end)) ||
										(new Date(formatedStartDate) <
											new Date(indispo.end) &&
											new Date(formatedEndDate) >=
												new Date(indispo.end)) ||
										(new Date(formatedEndDate) <=
											new Date(indispo.end) &&
											new Date(formatedEndDate) >
												new Date(indispo.start))
									) {
										isAvailableSlotsToAddUnavailability = false;
									}
								});
							}
						}
					});

					availabiltyDuration =
						dayDuration -
						(activitiesDuration + unavailabiltiesDuration);
					const unavailabilityDuration = (
						Math.abs(endDate - startDate) / 36e5
					).toFixed(2);

					if (
						planningStartDate !== null &&
						planningEndDate !== null
					) {
						const startDateMinute =
							startDate.getMinutes() < 10
								? `0${startDate.getMinutes()}`
								: startDate.getMinutes();
						const endDateMinute =
							endDate.getMinutes() < 10
								? `0${endDate.getMinutes()}`
								: endDate.getMinutes();
						const planningStartDateMinute =
							planningStartDate.getMinutes() < 10
								? `0${planningStartDate.getMinutes()}`
								: planningStartDate.getMinutes();
						const planningEndDateMinute =
							planningEndDate.getMinutes() < 10
								? `0${planningEndDate.getMinutes()}`
								: planningEndDate.getMinutes();

						const availabiltyDurationHours = (
							Math.abs(availabiltyDuration) / 36e5
						).toFixed(2);

						if (
							parseFloat(unavailabilityDuration) >
								parseFloat(availabiltyDurationHours) ||
							Number(
								`${startDate.getHours()}${startDateMinute}`,
							) <
								Number(
									`${planningStartDate.getHours()}${planningStartDateMinute}`,
								) ||
							Number(`${endDate.getHours()}${endDateMinute}`) >
								Number(
									`${planningEndDate.getHours()}${planningEndDateMinute}`,
								)
						) {
							isAddIndispo = false;
						}
					} else {
						isAddIndispo = false;
					}
				}

				if (dayDuration === 0) {
					isOpenPlanning = false;
				}

				if (!isOpenPlanning) {
					setStatus({
						error: "L'indisponibilité n'a pas été ajoutée. Veuillez ouvrir le planning.",
					});
				} else if (!isAvailableSlotsToAddUnavailability) {
					setStatus({
						error: "L'indisponibilité n'a pas été ajoutée. Le créneau horaire sélectionné est déjà pris par une autre indisponibilité.",
					});
				} else if (isAddIndispo) {
					setIsLoading(true);
					const result = await addUnaivability(
						formatedStartDate,
						formatedEndDate,
						// eslint-disable-next-line react/prop-types
						selectedResource.id,
					);
					if (result) {
						const res = await getCalendarEvents(resource);
						if (res) {
							setFormatedEvents(getFormatedEvents(res, theme));
						}
						NotificationManager.success(
							"L'indisponibilite a été bien ajoutée",
							'',
						);
						display('none');
						setStartDate('');
						setEndDate('');
						setStatus({
							error: '',
						});
						setIsLoading(false);
					} else {
						display('none');
						NotificationManager.error(
							"Une erreur s'est produite lors de l'ajout de l'indisponibilite",
							'',
						);
					}
				} else {
					setStatus({
						error: "La durée de votre indisponibilité est supérieure au temps restant disponible. L'indisponibilité n'a pas été ajoutée",
					});
				}
			} else {
				setStatus({
					error: "La date et l'heure de fin ne peuvent pas être inférieur à la date et l'heure de début",
				});
			}
		} else {
			setStatus({
				error: '',
				loading: false,
			});
			display('none');
		}
	};
	const filterPassedStartTime = (time) => {
		const currentDate = startDate;
		const selectedDate = new Date(time);

		return currentDate
			? currentDate.getTime() < selectedDate.getTime()
			: selectedDate.getTime();
	};
	const filterPassedEndTime = (time) => {
		const currentDate = endDate;
		const selectedDate = new Date(time);

		return currentDate
			? currentDate.getTime() > selectedDate.getTime()
			: selectedDate.getTime();
	};
	return (
		<>
			{showModalAddIndispo && (
				<Modal
					onClickCallback={handleAddIndispoClick}
					title="Ajouter une indisponibilité"
					cancelAction={isLoading ? '' : 'Annuler'}
					confirmAction={isLoading ? '' : 'Créer'}
					style={{
						position: 'fixed',
						width: isVersionPC() ? '20%' : '90%',
					}}
				>
					{!status.success && !isLoading ? (
						<StyledBlockModal>
							<StyledDateRow>Date :</StyledDateRow>
							<StyledDate>
								<DatePicker
									id="selected_date"
									selected={selectedDates}
									onChange={(date) => setSelectedDates(date)}
									dateFormat="dd/MM/yyyy"
									locale="fr"
									className="selected_date"
									customInput={
										<CustomInput placeholder="Sélectionner une date" />
									}
									placeholderText="Sélectionner une date"
									showWeekNumbers
									showMonthDropdown
									showYearDropdown
									isClearable
									minDate={new Date()}
									disableClock={true}
								/>
							</StyledDate>

							<StyledDateRow>Heure :</StyledDateRow>
							<StyledDateContainer>
								<StyledDateRow>
									<StyledBlockDateDeb>
										<DatePicker
											id="date_debut"
											selected={startDate}
											onChange={(date) =>
												setStartDate(date)
											}
											timeCaption="Heure début"
											dateFormat="HH:mm"
											showTimeSelect
											showTimeSelectOnly
											locale="fr"
											className="date_debut"
											customInput={
												<CustomInput placeholder="Début" />
											}
											placeholderText="Début"
											maxDate={endDate}
											filterTime={filterPassedEndTime}
											isClearable
											showWeekNumbers
											showMonthDropdown
											showYearDropdown
											minDate={new Date()}
											minTime={setHours(
												setMinutes(new Date(), 0),
												7,
											)}
											maxTime={setHours(
												setMinutes(new Date(), 0),
												19,
											)}
											disableClock={true}
										/>
									</StyledBlockDateDeb>
								</StyledDateRow>
								<StyledArrow>➔</StyledArrow>

								<StyledDateRow>
									<StyledBlockDateFin>
										<DatePicker
											id="date_fin"
											selected={endDate}
											onChange={(date) =>
												setEndDate(date)
											}
											timeCaption="Heure fin"
											dateFormat="HH:mm"
											showTimeSelect
											showTimeSelectOnly
											locale="fr"
											className="date_fin"
											customInput={
												<CustomInput placeholder="Fin" />
											}
											placeholderText="Fin"
											minDate={startDate}
											minTime={setHours(
												setMinutes(new Date(), 0),
												7,
											)}
											maxTime={setHours(
												setMinutes(new Date(), 0),
												19,
											)}
											filterTime={filterPassedStartTime}
											isClearable
											showWeekNumbers
											showMonthDropdown
											showYearDropdown
										/>
									</StyledBlockDateFin>
								</StyledDateRow>
							</StyledDateContainer>
							<StyledBlockErreurIndispo>
								{status.error ? (
									<StyledError>{status.error}</StyledError>
								) : null}
							</StyledBlockErreurIndispo>
						</StyledBlockModal>
					) : null}

					{status.success ? (
						<StyledSucess className="">
							{status.success}
						</StyledSucess>
					) : null}
					{isLoading ? (
						<StyledBlockModal>
							<Bars
								height="80"
								width="80"
								color="#b8cbf2"
								ariaLabel="bars-loading"
								wrapperStyle={{}}
								wrapperClass=""
								visible={true}
							/>
						</StyledBlockModal>
					) : null}
				</Modal>
			)}
		</>
	);
}

const CalendarAction = ({
	action,
	activity,
	display,
	selectedResource,
	formatedEvents,
	setFormatedEvents,
	setNewComment,
	theme,
	unavailability,
	setUnavailability,
	startWeekDate,
	endWeekDate,
	hasUndefinedTitle,
	isVersionPC,
}) => (
	<Switch test={action}>
		<div value={'editShift'}>
			<EditPlanning
				showModalEditPlanning={true}
				display={display}
				selectedResource={selectedResource}
				setFormatedEvents={setFormatedEvents}
				theme={theme}
				startWeekDate={startWeekDate}
				endWeekDate={endWeekDate}
				hasUndefinedTitle={hasUndefinedTitle}
				isVersionPC={isVersionPC}
			/>
		</div>
		<div value={'addUnavailable'}>
			<AddUnavailable
				showModalAddIndispo={true}
				display={display}
				selectedResource={selectedResource}
				setFormatedEvents={setFormatedEvents}
				theme={theme}
				isVersionPC={isVersionPC}
			/>
		</div>
	</Switch>
);

CalendarAction.propTypes = {
	action: PropTypes.string,
	activity: PropTypes.object,
	display: PropTypes.func,
	selectedResource: PropTypes.object,
	formatedEvents: PropTypes.array,
	setFormatedEvents: PropTypes.func,
	theme: PropTypes.object,
	unavailability: PropTypes.object,
	setUnavailability: PropTypes.func,
	startWeekDate: PropTypes.object,
	endWeekDate: PropTypes.object,
	hasUndefinedTitle: PropTypes.array,
	isVersionPC: PropTypes.func,
};

export default CalendarAction;
